import { titleCase } from './SqliteHelp.js'
export function makeEditViewsCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));

    let fieldTextEdit = ``
    tableDatas[tableName].forEach(tableItem => {
      if (tableItem.name != 'id') {
        fieldTextEdit = fieldTextEdit + `
            EasyInput(
              value: controller.${tableItem.name}.text,
              keyboardType: "${choiseTyp(tableItem.typ)}",
              title: "${titleCase(tableItem.epithet??tableItem.name)}",
              hintText: "请输入${titleCase(tableItem.epithet??tableItem.name)}：",
              values: (value) {
                controller.${tableItem.name}.text = value;
              },
            ),`
      }
    })

    return `/// Author: Samle\n/// get create page:edit_${tableName}
import 'dart:convert';
import 'package:flutter/cupertino.dart';
import 'package:flutter/material.dart';
import 'package:get/get.dart';

import '../controllers/edit_${tableName}_controller.dart';
/// 特殊自定义组件
import '../../../../util/EasyInput.dart';
    
class Edit${titleCase(tableName)}View extends GetView<Edit${titleCase(tableName)}Controller> {
  @override
  Widget build(BuildContext context) {
    return Scaffold(
      appBar: AppBar(
        leading: IconButton(
          icon: const Icon(Icons.arrow_back_ios),
          onPressed: Get.back
        ),
        elevation: 0,
        backgroundColor: Colors.black87,
        title: Text("Edit ${titleCase(tableName)}"),
        centerTitle: true,
        actions: <Widget>[
          IconButton(
            icon: const Icon(
              Icons.save,
              color: Colors.white,
            ),
            onPressed: (){controller.saveData();},
          ),
        ]
      ),
      body: Container(
        padding: const EdgeInsets.fromLTRB(20, 20, 20, 20),
        child: ListView(
          children: [${fieldTextEdit}
          ],
        ),
      ),
    );
  }
}
`
}

export function choiseTyp(typ){
  if (typ == 'INTEGER PRIMARY KEY AUTOINCREMENT') {
    return "number"
  } else if (typ == 'INTEGER') {
    return "number"
  } else if (typ == 'FLOAT') {
    return "number"
  } else {
    return "text"
  }
}
